import { Navigate, Outlet, Routes } from "react-router-dom";
import { RoutesLink } from "../../ApiHelper/RoutesLink";
import { useSelector } from "react-redux";

const ProtectedDepartmentRoute = ({ allowedDepartments = [] }) => {
  const userDetails = useSelector((state) => state.root.userDetails);
  const department = userDetails?.department?.name;
  const userType = userDetails?.type;
  if (!allowedDepartments.includes(department) && userType === 1) {
    return <Navigate to={RoutesLink?.forbidden_403} />; 
  }

  return <Outlet />;
};

export default ProtectedDepartmentRoute;
